import { StudiesScreen } from '../features/console';

export function TrialsPage() {
  return <StudiesScreen />;
}
